import { useEffect, useState } from "react";
import axios from "axios";

const TransformStreamView = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios.get("http://localhost:8000/sheet", {
      params: {
        spreadsheet_id: "ID_DEL_GOOGLE_SHEET",
        rango: "Hoja1"
      }
    })
    .then(res => setData(res.data.data))
    .catch(err => console.error(err));
  }, []);

  const handleChange = (rowIndex, key, value) => {
    const updated = [...data];
    updated[rowIndex][key] = value;
    setData(updated);
  };

  if (data.length === 0) return <p>Cargando...</p>;

  return (
    <table border="1">
      <thead>
        <tr>
          {Object.keys(data[0]).map(col => (
            <th key={col}>{col}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, i) => (
          <tr key={i}>
            {Object.entries(row).map(([key, value]) => (
              <td key={key}>
                <input
                  value={value}
                  onChange={e => handleChange(i, key, e.target.value)}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TransformStreamView;
